import { useOrganization, useSession } from "@clerk/react";
import { useEffect, useState } from "react";

export function useOnboardingComplete() {
  const { session, isLoaded: sessionLoaded } = useSession();
  const [onboardingComplete, setOnboardingComplete] = useState(false);
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    if (!sessionLoaded) return;

    const memberships = session?.user?.organizationMemberships;
    const isComplete = !!(memberships && memberships.length > 0);

    setOnboardingComplete(isComplete);
    setIsLoaded(true);

    if (isComplete) {
      localStorage.setItem("onboardingComplete", "true");
    }
  }, [session, sessionLoaded]);

  return { onboardingComplete, isLoaded };
}

export function usePaywallComplete() {
  const { organization, isLoaded: orgLoaded } = useOrganization();
  const [paywallComplete, setPaywallComplete] = useState(false);
  const [isLoaded, setIsLoaded] = useState(false);
  const [planName, setPlanName] = useState<string | null>(null);

  useEffect(() => {
    if (!orgLoaded) return;

    const publicMetadata = organization?.publicMetadata as {
      plan_name?: string;
      has_plan?: boolean;
      trial_expired?: boolean;
    } | null;

    const isComplete = !!(publicMetadata && publicMetadata.has_plan);

    if (publicMetadata?.trial_expired) {
      setPaywallComplete(true);
      setPlanName("free");
      setIsLoaded(true);
      return;
    }
    setPlanName(publicMetadata?.plan_name ?? null);
    setPaywallComplete(isComplete);
    setIsLoaded(true);
  }, [organization, orgLoaded]);

  return { paywallComplete, isLoaded, planName };
}

export function useTrialExpired() {
  const { organization, isLoaded: orgLoaded } = useOrganization();
  const [trialExpired, setTrialExpired] = useState(false);
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    if (!orgLoaded) return;

    const publicMetadata = organization?.publicMetadata as {
      plan_name?: string;
      has_plan?: boolean;
      trial_expired?: boolean;
    } | null;

    // console.log("Paywall complete:", publicMetadata);
    setTrialExpired(!!(publicMetadata && publicMetadata.trial_expired));
    setIsLoaded(true);
  }, [organization, orgLoaded]);

  return { trialExpired, isLoaded };
}
